import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Field, reduxForm, formValueSelector, change } from 'redux-form';

import { deepDiver } from 'helpers/utilities';
import SelectField from 'helpers/reduxFormMaterialUiNext/Select';
import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import Checkbox from 'helpers/reduxFormMaterialUiNext/Checkbox';
import { Toggle } from 'redux-form-material-ui';
import { colors } from 'helpers/ColorHelper';
import * as validator from 'helpers/Validator';
import * as formatter from 'helpers/Formatter';
import SearchableSelectRedux from 'components/shared/SearchableSelectRedux';
import range from 'lodash/range';

import ReduxDropzone from 'components/shared/ReactDropzoneReduxComponent';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from 'material-ui/MenuItem';

import { CSSTransitionGroup } from 'react-transition-group';
import { getTranslatedString } from 'helpers/i18n';
import DatePickerAccessible from 'helpers/reduxFormMaterialUiNext/DatePickerAccessible';

const style = {
  receipt_header: {
    margin: '0px -20px 10px -20px',
    backgroundColor: '#f1f1f1',
    padding: '5px 10px',
    fontSize: '14px',
    fontWeight: '800',
    color: 'rgba(78, 78, 78, 0.6)',
  },
};

const FORM_NAME = 'add_amenity_form';

class AmenityForm extends Component {
  clearOfflineDates = (event, checked) => {
    this.props.change(FORM_NAME, 'offline_starts_at', null);
    this.props.change(FORM_NAME, 'offline_ends_at', null);
  };

  validateAmenityMin = (minBookingTime, maxBookingTime) => {
    if (!minBookingTime || !maxBookingTime) return undefined;
    if (minBookingTime <= maxBookingTime) return undefined;

    return (
      <FormHelperText style={{ color: 'red' }}>
        {getTranslatedString('amenityMinGreaterThenMax')}
      </FormHelperText>
    );
  };

  validateAmenityMax = (minBookingTime, maxBookingTime) => {
    if (!minBookingTime || !maxBookingTime) return undefined;
    if (maxBookingTime >= minBookingTime) return undefined;

    return (
      <FormHelperText style={{ color: 'red' }}>
        {getTranslatedString('amenityMaxLessThenMin')}
      </FormHelperText>
    );
  };

  render() {
    const { properties, handleSubmit, amenityDurationType, disabled } = this.props;
    let bookingTimeOptions = [];
    if (amenityDurationType === 'night') {
      // Nightly translations
      bookingTimeOptions = [
        [0, getTranslatedString('landlordPortal.amenities.time_unit.none')],
        [1, `1 ${getTranslatedString('landlordPortal.amenities.time_unit.night')}`],
      ];
      bookingTimeOptions = bookingTimeOptions.concat(
        range(2, 31).map(count => {
          let translation = getTranslatedString('landlordPortal.amenities.time_unit.nights');
          return [count, `${count} ${translation}`];
        })
      );
    } else if (amenityDurationType === 'hour') {
      // Hourly translations
      bookingTimeOptions = [
        [0, getTranslatedString('landlordPortal.amenities.time_unit.none')],
        [0.5, `0.5 ${getTranslatedString('landlordPortal.amenities.time_unit.hours')}`],
        [1, `1 ${getTranslatedString('landlordPortal.amenities.time_unit.hour')}`],
      ];
      bookingTimeOptions = bookingTimeOptions.concat(
        range(1.5, 12, 0.5).map(count => {
          let translation = getTranslatedString('landlordPortal.amenities.time_unit.hours');
          return [count, `${count} ${translation}`];
        })
      );
    } else {
      // Daily translations
      bookingTimeOptions = [[0, getTranslatedString('landlordPortal.amenities.time_unit.fullDay')]];
    }

    const listItems = bookingTimeOptions.map(option => (
      <MenuItem key={option[0]} value={option[0]}>
        {option[1]}
      </MenuItem>
    ));

    return (
      <form onSubmit={handleSubmit}>
        <div className="row" style={style.receipt_header}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {getTranslatedString('landlordPortal.amenities.form.property')}
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12" style={{ margin: '10px 0' }}>
            <Field
              disabled={disabled}
              name="property_for_multiselect"
              component={SearchableSelectRedux}
              options={properties}
              isMulti
              placeholder={getTranslatedString('landlordPortal.amenities.form.property_select')}
              hintText={getTranslatedString('landlordPortal.amenities.form.property')}
              innerDivStyle={{
                width: '100%',
                fontSize: '15px',
                fontWeight: '100 !important',
              }}
              validate={[validator.required]}
              menuStyle={{ minWidth: '250px', fontSize: '15px' }}
              style={{ fontSize: '15px' }}
              fullWidth
            />
          </div>
        </div>

        <div className="row" style={style.receipt_header}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {getTranslatedString('landlordPortal.amenities.form.details').toUpperCase()}
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12" style={{ margin: 'auto' }}>
            <Field
              disabled={disabled}
              name="name"
              component={TextField}
              label={getTranslatedString('landlordPortal.amenities.form.name')}
              validate={[validator.required]}
            />
          </div>

          <div className="col-xs-12" style={{ marginTop: '10px' }}>
            <FormControl>
              <InputLabel htmlFor="amenity-type">
                {getTranslatedString('landlordPortal.amenities.form.amenity_type')}
              </InputLabel>
              <Field
                disabled={disabled}
                name="amenity_type"
                component={SelectField}
                validate={[validator.required]}
                placeholder={getTranslatedString('landlordPortal.amenities.form.amenity_type')}
              >
                <MenuItem value={0}>
                  {' '}
                  {getTranslatedString('landlordPortal.amenities.form.amenity_type.bbq')}{' '}
                </MenuItem>
                <MenuItem value={1}>
                  {' '}
                  {getTranslatedString(
                    'landlordPortal.amenities.form.amenity_type.moving_elevator'
                  )}{' '}
                </MenuItem>
                <MenuItem value={2}>
                  {' '}
                  {getTranslatedString(
                    'landlordPortal.amenities.form.amenity_type.guest_suite'
                  )}{' '}
                </MenuItem>
                <MenuItem value={3}>
                  {' '}
                  {getTranslatedString('landlordPortal.amenities.form.amenity_type.parking')}{' '}
                </MenuItem>
                <MenuItem value={4}>
                  {' '}
                  {getTranslatedString('landlordPortal.amenities.form.amenity_type.room')}{' '}
                </MenuItem>
                <MenuItem value={5}>
                  {' '}
                  {getTranslatedString(
                    'landlordPortal.amenities.form.amenity_type.inspection'
                  )}{' '}
                </MenuItem>
                <MenuItem value={7}>
                  {' '}
                  {getTranslatedString(
                    'landlordPortal.amenities.form.amenity_type.meeting_room'
                  )}{' '}
                </MenuItem>
              </Field>
            </FormControl>
          </div>

          <div className="col-xs-12" style={{ marginTop: '10px' }}>
            <FormControl>
              <InputLabel htmlFor="amenity-duration-type">
                {getTranslatedString('landlordPortal.amenities.form.duration_type')}
              </InputLabel>
              <Field
                disabled={disabled}
                name="amenity_duration_type"
                component={SelectField}
                validate={[validator.required]}
                placeholder={getTranslatedString('landlordPortal.amenities.form.duration_type')}
              >
                <MenuItem value={'hour'}>
                  {getTranslatedString('landlordPortal.amenities.time_unit.hourly')}
                </MenuItem>
                <MenuItem value={'day'}>
                  {getTranslatedString('landlordPortal.amenities.time_unit.fullDay')}
                </MenuItem>
                <MenuItem value={'night'}>
                  {getTranslatedString('landlordPortal.amenities.time_unit.nightly')}
                </MenuItem>
              </Field>
            </FormControl>
          </div>

          <div className="col-xs-12" style={{ marginTop: '10px' }}>
            <Field
              disabled={disabled}
              name="description"
              component={TextField}
              label={getTranslatedString('landlordPortal.amenities.form.description')}
              validate={[validator.required]}
              multiline
            />
          </div>

          <div className="col-xs-12" style={{ marginTop: '10px' }}>
            <Field
              disabled={disabled}
              name="details"
              component={TextField}
              label={getTranslatedString('landlordPortal.amenities.form.additional_info')}
              validate={[validator.required]}
              multiline
            />
          </div>

          <div className="col-xs-12" style={{ marginTop: '10px', marginBottom: '15px' }}>
            <FormControl>
              <InputLabel htmlFor="min_booking_time">
                {getTranslatedString('landlordPortal.amenities.form.min_time')}
              </InputLabel>
              <Field
                disabled={disabled}
                name="min_booking_time"
                component={SelectField}
                validate={[validator.required, validator.validateAmenityMin]}
                placeholder={getTranslatedString('landlordPortal.amenities.form.min_time')}
              >
                {listItems}
              </Field>
              {this.validateAmenityMin(
                this.props.minBookingDuration,
                this.props.maxBookingDuration
              )}
            </FormControl>
          </div>

          <div className="col-xs-12" style={{ marginTop: '10px', marginBottom: '15px' }}>
            <FormControl>
              <InputLabel htmlFor="max_booking_time">
                {getTranslatedString('landlordPortal.amenities.form.max_time')}
              </InputLabel>
              <Field
                disabled={disabled}
                name="max_booking_time"
                component={SelectField}
                validate={[validator.required, validator.validateAmenityMax]}
                placeholder={getTranslatedString('landlordPortal.amenities.form.max_time')}
              >
                {listItems}
              </Field>
              {this.validateAmenityMax(
                this.props.minBookingDuration,
                this.props.maxBookingDuration
              )}
            </FormControl>
          </div>

          <div className="col-xs-12" style={{ marginTop: '10px', marginBottom: '15px' }}>
            <FormControl>
              <Field
                disabled={disabled}
                name="twenty_four_hour_booking_notifications"
                type="toggle"
                component={Toggle}
                label={getTranslatedString(
                  'landlordPortal.amenities.form.notifyInTwentyFourHours.label'
                )}
              />
            </FormControl>
            <p>
              {getTranslatedString(
                'landlordPortal.amenities.form.notifyInTwentyFourHours.description'
              )}
            </p>
          </div>

          <CSSTransitionGroup
            transitionName="slide_up"
            transitionEnterTimeout={200}
            transitionLeaveTimeout={200}
          >
            {this.renderEmailFields(disabled)}
          </CSSTransitionGroup>
          <div className="row" />

          <div className="col-xs-12" style={{ marginTop: '10px', marginBottom: '15px' }}>
            <FormControl>
              <Field
                disabled={disabled}
                name="email_notifications_enabled"
                type="toggle"
                component={Toggle}
                label={getTranslatedString(
                  'landlordPortal.amenities.form.emailNotifications.label'
                )}
              />
            </FormControl>
            <p>
              {getTranslatedString('landlordPortal.amenities.form.emailNotifications.description')}
            </p>
          </div>

          <div className="col-xs-12" style={{ padding: '0' }}>
            <FormControlLabel
              control={
                <Field name="offline" component={Checkbox} onChange={this.clearOfflineDates} />
              }
              label={getTranslatedString('landlordPortal.amenities.form.offline')}
            />
          </div>
        </div>

        <CSSTransitionGroup
          transitionName="slide_up"
          transitionEnterTimeout={200}
          transitionLeaveTimeout={200}
        >
          {this.renderOfflineFields()}
        </CSSTransitionGroup>

        {this.renderPhoto()}
        <div className="row" />
      </form>
    );
  }

  renderPhoto = () => {
    const { disabled } = this.props;
    return (
      <React.Fragment>
        <div className="row" style={style.receipt_header}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {getTranslatedString('landlordPortal.amenities.form.photo').toUpperCase()}
            </p>
          </div>
        </div>
        <div className="row" style={{ textAlign: 'center' }}>
          {disabled ? this._renderReadonlyPhoto() : this._renderEditablePhoto()}
        </div>
      </React.Fragment>
    );
  };

  _renderEditablePhoto = () => {
    return (
      <Field
        name="image"
        validate={[validator.required]}
        style={{
          border: `1px dashed ${colors.LIGHT_GRAY}`,
          width: '60%',
          margin: 'auto',
        }}
        labelText={getTranslatedString('landlordPortal.amenities.form.add_photo')}
        component={ReduxDropzone}
        fileValidation="image/*"
        size={120}
        multiple={false}
      />
    );
  };

  _renderReadonlyPhoto = () => {
    const { amenityImage } = this.props;
    return (
      <img
        style={{
          border: `1px dashed ${colors.LIGHT_GRAY}`,
          width: '120px',
          margin: 'auto',
          paddingBottom: '12px',
        }}
        src={amenityImage}
        alt="Amenity"
      />
    );
  };

  renderEmailFields = disabled => {
    if (!this.props.twenty_four_hour_booking_notifications) return null;

    return (
      <div className="row" style={{ marginBottom: '20px' }}>
        <div className="col-sm-12">
          <Field
            disabled={disabled}
            name="twenty_four_hour_booking_notification_emails"
            component={TextField}
            label={getTranslatedString('landlordPortal.landlordTenants.email')}
          />
        </div>
      </div>
    );
  };

  renderOfflineFields = () => {
    if (!this.props.offline) return null;

    return (
      <div className="row" style={{ marginBottom: '20px' }}>
        <div className="col-sm-6">
          <Field
            name="offline_starts_at"
            component={DatePickerAccessible}
            label={getTranslatedString('landlordPortal.amenities.form.offline_start')}
            style={{ fontSize: '14px', width: '100%' }}
            textFieldStyle={{ fontSize: '14px', width: '100%' }}
            formatDate={formatter.reformatDate}
            autoOk
            validate={[validator.dateOfflineRange, validator.required]}
          />
        </div>
        <div className="col-sm-6">
          <Field
            name="offline_ends_at"
            component={DatePickerAccessible}
            label={getTranslatedString('landlordPortal.amenities.form.offline_end')}
            style={{ fontSize: '14px', width: '100%' }}
            textFieldStyle={{ fontSize: '14px', width: '100%' }}
            formatDate={formatter.reformatDate}
            autoOk
            validate={[validator.dateOfflineRange, validator.required]}
          />
        </div>
      </div>
    );
  };
}

const selector = formValueSelector(FORM_NAME);

let ConnectedAmenityForm = connect(
  state => ({
    amenityDurationType: selector(state, 'amenity_duration_type'),
    offline: selector(state, 'offline'),
    amenityImage: deepDiver(state, 'form.add_amenity_form.values.image'),
    minBookingDuration: selector(state, 'min_booking_time'),
    maxBookingDuration: selector(state, 'max_booking_time'),
    twenty_four_hour_booking_notifications: selector(
      state,
      'twenty_four_hour_booking_notifications'
    ),
  }),
  {
    change,
  }
)(AmenityForm);

ConnectedAmenityForm = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
  initialValues: { properties: [] },
})(ConnectedAmenityForm);

export default ConnectedAmenityForm;
